import React from "react";
import { Outlet } from "react-router-dom";

function SupplyProcessLayout() {
  return (
    <>
      <Outlet />
    </>
  );
}

export default SupplyProcessLayout;
